import axiosInstance from "../axios/axiosInstance";
import AuthorizationService from "./AuthorizationService";
import config from "./Config";
import RoleService from "./RoleService";

export default class AgendamentoService {
    async listTipoAgendamentos(iss) {
        const accessLevel = AuthorizationService.getResourceAccessLevel('agendamento-tipo');
        const idPrestador = RoleService.getPrestador();

        switch (accessLevel) {
            case 'GLOBAL':
                return this.listAllTipoAgendamento(iss);
            case 'COMPANY':
                return this.listAllTipoAgendamento(iss);
            case 'SELF':
                return this.getTipoAgendamentoByPrestador(iss, idPrestador);
            default:
                throw new Error('Acesso não autorizado');
        }
    }

    /// TIPO AGENDAMENTO ///
    listAllTipoAgendamento(data) {
        return axiosInstance.get(`${config.api.version}/agendamento/tipo/${data}/get`)
    }

    getTipoAgendamento(data, id) {
        var params = { all: true }
        return axiosInstance.get(`${config.api.version}/agendamento/tipo/${data}/get/${id}`, {
            params: params
        })
    }

    getTipoAgendamentoByPrestador(data, prestadorId) {
        return axiosInstance.get(`${config.api.version}/agendamento/tipo/${data}/get?prestador.id=${prestadorId}&join=true`)
    }

    postTipoAgendamento(data, agendamento) {
        return axiosInstance.post(`${config.api.version}/agendamento/tipo/${data}/`, agendamento)
    }

    putTipoAgendamento(data, agendamento, id) {
        return axiosInstance.put(`${config.api.version}/agendamento/tipo/${data}/${id}`, agendamento)
    }

    deleteTipoAgendamento(data, id) {
        return axiosInstance.delete(`${config.api.version}/agendamento/tipo/${data}/${id}`)
    }
}